/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PosOrder_viewer$ref = any;
export type routes_PosOrder_QueryVariables = {|
  ids: $ReadOnlyArray<string>,
  storeIds: $ReadOnlyArray<string>,
|};
export type routes_PosOrder_QueryResponse = {|
  +viewer: ?{|
    +salesPosOrders: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +firstname: ?string,
          +lastname: ?string,
          +email: ?string,
          +telephone: ?string,
          +company: ?string,
          +paymentMethod: ?string,
          +surcharges: ?$ReadOnlyArray<?{|
            +name: ?string,
            +amount: ?number,
          |}>,
          +subtotal: ?number,
          +grandTotal: ?number,
          +operator: ?string,
          +store: ?{|
            +id: string,
            +name: ?string,
          |},
          +insertedAt: ?string,
          +lines: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +quantity: ?number,
                +unitPrice: ?number,
                +unitDiscount: ?number,
                +unitSurcharge: ?number,
                +rowTotal: ?number,
                +product: ?{|
                  +urlSlug: ?string,
                  +status: ?string,
                  +mainImage: ?{|
                    +id: string,
                    +url: ?string,
                    +thumbnail: ?string,
                  |},
                |},
              |}
            |}>
          |},
        |}
      |}>
    |},
    +$fragmentRefs: PosOrder_viewer$ref,
  |}
|};
export type routes_PosOrder_Query = {|
  variables: routes_PosOrder_QueryVariables,
  response: routes_PosOrder_QueryResponse,
|};
*/


/*
query routes_PosOrder_Query(
  $ids: [ID!]!
  $storeIds: [String!]!
) {
  viewer {
    ...PosOrder_viewer
    salesPosOrders(first: 1, ids: $ids, storeIds: $storeIds) {
      edges {
        node {
          id
          name
          firstname
          lastname
          email
          telephone
          company
          paymentMethod
          surcharges {
            name
            amount
          }
          subtotal
          grandTotal
          operator
          store {
            id
            name
          }
          insertedAt
          lines(first: 999) {
            edges {
              node {
                id
                name
                quantity
                unitPrice
                unitDiscount
                unitSurcharge
                rowTotal
                product {
                  urlSlug
                  status
                  mainImage {
                    id
                    url
                    thumbnail
                  }
                  id
                }
              }
            }
          }
        }
      }
    }
    id
  }
}

fragment PosOrder_viewer on Customer {
  salesPosOrders(first: 1, ids: $ids, storeIds: $storeIds) {
    edges {
      node {
        id
        name
        firstname
        lastname
        email
        telephone
        company
        paymentMethod
        surcharges {
          name
          amount
        }
        subtotal
        grandTotal
        operator
        store {
          id
          name
        }
        insertedAt
        lines(first: 999) {
          edges {
            node {
              id
              name
              quantity
              unitPrice
              unitDiscount
              unitSurcharge
              rowTotal
              product {
                urlSlug
                status
                mainImage {
                  id
                  url
                  thumbnail
                }
                id
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeIds"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  },
  {
    "kind": "Variable",
    "name": "storeIds",
    "variableName": "storeIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstname",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastname",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "telephone",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "company",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentMethod",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderSurcharge",
  "kind": "LinkedField",
  "name": "surcharges",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtotal",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grandTotal",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "operator",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insertedAt",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitPrice",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitDiscount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitSurcharge",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowTotal",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "mainImage",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_PosOrder_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SalesPosOrderConnection",
            "kind": "LinkedField",
            "name": "salesPosOrders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesPosOrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesPosOrder",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": (v16/*: any*/),
                        "concreteType": "SalesOrderLineConnection",
                        "kind": "LinkedField",
                        "name": "lines",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrderLineEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrderLine",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "lines(first:999)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PosOrder_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_PosOrder_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SalesPosOrderConnection",
            "kind": "LinkedField",
            "name": "salesPosOrders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesPosOrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesPosOrder",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": (v16/*: any*/),
                        "concreteType": "SalesOrderLineConnection",
                        "kind": "LinkedField",
                        "name": "lines",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrderLineEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrderLine",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "lines(first:999)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "002a7aa0035c362cadd948b7b226509b",
    "id": null,
    "metadata": {},
    "name": "routes_PosOrder_Query",
    "operationKind": "query",
    "text": "query routes_PosOrder_Query(\n  $ids: [ID!]!\n  $storeIds: [String!]!\n) {\n  viewer {\n    ...PosOrder_viewer\n    salesPosOrders(first: 1, ids: $ids, storeIds: $storeIds) {\n      edges {\n        node {\n          id\n          name\n          firstname\n          lastname\n          email\n          telephone\n          company\n          paymentMethod\n          surcharges {\n            name\n            amount\n          }\n          subtotal\n          grandTotal\n          operator\n          store {\n            id\n            name\n          }\n          insertedAt\n          lines(first: 999) {\n            edges {\n              node {\n                id\n                name\n                quantity\n                unitPrice\n                unitDiscount\n                unitSurcharge\n                rowTotal\n                product {\n                  urlSlug\n                  status\n                  mainImage {\n                    id\n                    url\n                    thumbnail\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment PosOrder_viewer on Customer {\n  salesPosOrders(first: 1, ids: $ids, storeIds: $storeIds) {\n    edges {\n      node {\n        id\n        name\n        firstname\n        lastname\n        email\n        telephone\n        company\n        paymentMethod\n        surcharges {\n          name\n          amount\n        }\n        subtotal\n        grandTotal\n        operator\n        store {\n          id\n          name\n        }\n        insertedAt\n        lines(first: 999) {\n          edges {\n            node {\n              id\n              name\n              quantity\n              unitPrice\n              unitDiscount\n              unitSurcharge\n              rowTotal\n              product {\n                urlSlug\n                status\n                mainImage {\n                  id\n                  url\n                  thumbnail\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e01f7af1d4bddbb656aa29716e12c0e9';

module.exports = node;
